import React, { useLayoutEffect, useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';

function useIsOverflowing(ref) {
  const [isOverflowing, setIsOverflowing] = useState(undefined);

  const buffer = 15;

  useLayoutEffect(() => {
    setIsOverflowing(ref.current.scrollWidth - buffer > ref.current.clientWidth);
  }, [ref]);

  useResizeObserver(ref, (entry) => setIsOverflowing(entry.target.scrollWidth - buffer > entry.target.clientWidth));

  return isOverflowing;
}

export default useIsOverflowing;
